import React from "react"
import classes from "./searchTrigger.module.css"

interface SearchTriggerProps {
  onClick: () => void
  isOpen: boolean
  showHeader: boolean
}

// eslint-disable-next-line react/display-name
const SearchTrigger = React.forwardRef<HTMLButtonElement, SearchTriggerProps>(
  ({ onClick, isOpen, showHeader }, ref) => {
    return (
      <button
        aria-label="search"
        onClick={onClick}
        className="flex cursor-pointer items-center justify-start rounded-[5px] hover_bg-[#F7F7F5] lg_h-[45px] lg_px-[10px]"
      >
        <span className={classes.icon} />
        {!showHeader && (
          <span className="ml-[6px] hidden font-sans text-sm text-primary lg_block">
            Search
          </span>
        )}
      </button>
    )
  }
)

export default SearchTrigger
